import StatusIndicatorTemplate from '../reusable/StatusIndicatorTemplate'

export const convertMilliToSecEpochTime = (time) => {
    return Math.floor(time / 1000)
}

export const EMPTY_BANNER_EXPIRATION_DATE = ''
export const EMPTY_BANNER_MESSAGE = ''

export const getColumnDef = (businessEntities: any[] = []) => [
    {
        id: 'value',
        header: 'Banner ID',
        cell: (item) => item.value,
    },
    {
        id: 'message',
        header: 'Message',
        cell: (item) => item.message || '-',
    },
    {
        id: 'banner_type',
        header: 'Type',
        cell: (item) => item.banner_type || '-',
    },
    {
        id: 'removable',
        header: 'Removable Banner',
        cell: (item) => <StatusIndicatorTemplate value={item.removable} />,
        sortingField: 'removable',
    },
    {
        id: 'ttl',
        header: 'Expiration Date',
        cell: (item) => convertEpochToTimeString(item.ttl) || '-',
        sortingField: 'ttl',
    },
    {
        id: 'cross_business_entity',
        header: 'Cross-BE?',
        cell: (item) => <StatusIndicatorTemplate value={item.cross_business_entity ?? true} />,
        sortingField: 'cross_business_entity',
    },
    {
        id: 'business_entities',
        header: 'Business Entities',
        cell: (item) => {
            if (item.cross_business_entity ?? true) {
                return 'All'
            }

            // Map BE IDs to names
            const beNames: string[] = item.business_entities
                .map((id) => {
                    const be = businessEntities.find((entity) => entity.business_entity_id === id)
                    return be ? be.business_entity_name : id // fallback to ID if name not found
                })
                .sort((be1, be2) => (be1 < be2 ? -1 : 1))

            return beNames.join(', ')
        },
    },
    {
        id: 'is_falcon',
        header: 'Is Falcon?',
        cell: (item) => <StatusIndicatorTemplate value={item.is_falcon ?? true} />,
        sortingField: 'is_falcon',
    },
    {
        id: 'is_egret',
        header: 'Is Egret?',
        cell: (item) => <StatusIndicatorTemplate value={item.is_egret ?? false} />,
        sortingField: 'is_egret',
    },
]

export const bannerVisibleColumns = [
    'message',
    'banner_type',
    'removable',
    'ttl',
    'cross_business_entity',
    'business_entities',
    'is_falcon',
    'is_egret',
]

export const convertEpochToTimeString = (time) => {
    const milliTime = time * 1000
    return new Date(milliTime).toUTCString()
}
export interface BannerAlertType {
    content: string
    id: string
    type: string
    dismissible: boolean
    onDismiss: () => void
}

export interface BannerType {
    value: string
    message: string
    removable: boolean
    type: string
    ttl: number
    cross_business_entity?: boolean
    business_entities?: string[]
    is_falcon?: boolean
    is_egret?: boolean
}

export const BANNER_TYPE = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
    INFO: 'info',
    NOT_SET: 'not_set',
}

export const BANNER_TYPE_OPTIONS = [
    { label: 'Select Banner Type', value: BANNER_TYPE.NOT_SET },
    {
        label: 'Info',
        value: BANNER_TYPE.INFO,
        description: 'Blue banner, for informational messages',
    },
    {
        label: 'Error',
        value: BANNER_TYPE.ERROR,
        description: 'Red banner, for urgent alerts or errors',
    },
    {
        label: 'Success',
        value: BANNER_TYPE.SUCCESS,
        description: 'Green banner, for successful actions or operations',
    },
    {
        label: 'Warning',
        value: BANNER_TYPE.WARNING,
        description: 'Yellow banner, for warnings or alerts',
    },
]
export const EMPTY_BANNER: BannerType = {
    value: '',
    message: '',
    ttl: 0,
    type: BANNER_TYPE.NOT_SET,
    removable: true,
}
export const isDateEnabled = (date: Date) => {
    const today = new Date()
    return date >= today
}

export const getDefaultExpirationDate = () => {
    const today = new Date()
    today.setDate(today.getDate() + 1)
    return today.toISOString().split('T')[0]
}

export const shouldShowBanner = (banner: BannerType, selectedBusinessEntityId: string) => {
    // Check business entity filtering - default to true if undefined
    const showBannerForAllBes = banner.cross_business_entity ?? true
    const showBannerForBe = (banner.business_entities ?? []).includes(selectedBusinessEntityId)
    const passesBusinessEntityFilter = showBannerForAllBes || showBannerForBe

    // Show only banners that are is_falcon true or undefined/null (default true)
    const isFalconBanner = banner.is_falcon ?? true

    return isFalconBanner && passesBusinessEntityFilter
}
